@if (!hasError) {
<div
 (click)="loadPreview()"
 (keypress.enter)="loadPreview()"
 tabindex="0"
 class="relative bg-black/80 backdrop-blur-md pointer-events-auto w-48 h-[100px] md:h-[105px] cursor-pointer rounded-md overflow-hidden group hover:scale-95 transition-transform">

    <!-- BACKGROUND BLUR -->
    <div 
        class="absolute inset-0 bg-transparent backdrop-blur-sm transition-opacity" 
        [class]="loading ? 'opacity-100' : 'opacity-0 duration-1000'">
    </div>

    <!-- MAIN THUMBNAIL -->
    <img 
        class="w-full h-full object-cover" 
        [src]="thumbnail" 
        [alt]="preview.label + ' thumbnail'"
    />

    <!-- THUMBNAIL LABEL -->
    <div class="absolute bottom-0 w-full text-center bg-[#333333] group-hover:bg-black transition-colors">
        <p class="text-white">
            <span class="uppercase text-[0.65rem] font-semibold" [class]="{'animate-pulse': loading}">
                {{ loading ? 'Loading' : preview.label}}
            </span>
        </p>
    </div>

</div>
}